document.addEventListener("DOMContentLoaded", () => {
  const marqueeContainers = document.querySelectorAll("[data-marquee-container]")

  marqueeContainers.forEach((container) => {
    const calculateAndSetAnimation = () => {
      const marqueeContent = container.querySelector("[data-marquee-content]")
      if (!marqueeContent) return

      // Get the width of ONE content block (the first copy)
      const contentWidth = marqueeContent.offsetWidth
      const containerElement = container

      // Calculate the distance to translate: -1 full content width for seamless loop
      const translateDistance = -contentWidth

      // Set CSS variable for animation
      containerElement.style.setProperty("--translate-distance", `${translateDistance}px`)
    }

    // Calculate on load
    calculateAndSetAnimation()

    // Recalculate on window resize to handle responsive changes
    window.addEventListener("resize", calculateAndSetAnimation)

    // Also observe for content changes
    const observer = new MutationObserver(calculateAndSetAnimation)
    observer.observe(container, { childList: true, subtree: true })
  })
})
